import { differenceInDays } from 'date-fns/differenceInDays';
import { format } from 'date-fns/format';
import formatCloseRelative from '../Util/formatCloseRelative';

export function getDateStrings(startTime: Date, endTime?: Date, now: Date = new Date()): { from: string; to: string } {
    let from: string;
    let to: string = 'Gäller tills vidare';
    if (endTime && format(startTime, 'yyyy-MM-dd') === format(endTime, 'yyyy-MM-dd')) {
        from = `${formatCloseRelative(startTime, 'noTime', now)} kl. ${format(startTime, 'HH.mm')} - ${format(endTime, 'HH.mm')}`;
        to = undefined;
    } else if (endTime && Math.abs(differenceInDays(startTime, endTime)) < 3) {
        from = `${formatCloseRelative(startTime, 'includeTime', now)}`;
        to = `${formatCloseRelative(endTime, 'includeTime', now)}`;
    } else {
        from = `${formatCloseRelative(startTime, 'includeTime', now)}`;
        if (endTime) to = `${formatCloseRelative(endTime, 'includeTime', now)}`;
    }

    return { from, to };
}
